var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7Z",
    fill: "#224682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.75739C12.5522 6.75739 13 7.2051 13 7.75739V11H16.2426C16.7949 11 17.2426 11.4477 17.2426 12C17.2426 12.5523 16.7949 13 16.2426 13H13V16.2427C13 16.795 12.5522 17.2427 12 17.2427C11.4477 17.2427 11 16.795 11 16.2427V13H7.75732C7.20504 13 6.75732 12.5523 6.75732 12C6.75732 11.4477 7.20504 11 7.75732 11H11V7.75739C11 7.2051 11.4477 6.75739 12 6.75739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxAdd);
export default __webpack_public_path__ + "static/media/checkbox-add.f1f0edd56cd460a038a4d458a004d192.svg";
export { ForwardRef as ReactComponent };